// extracted by mini-css-extract-plugin
export var box = "InfoboxModule-module--box--2l8YA";
export var content = "InfoboxModule-module--content--pJx41";
export var text = "InfoboxModule-module--text--IFOKd";
export var title = "InfoboxModule-module--title--jD2D-";